import dayjs from 'dayjs';
import { loadSelectedShiftDetail } from '../services/shiftService';


const useShiftDetailLoader = ({
  setShiftCode,
  setCheckInTime,
  setCheckOutTime,
  setBreakDurationMins,
  setDescription,
  setBreaks,
  setLoading,
}) => {
  const loadShiftDetail = async (id) => {
    const p_companyid = localStorage.getItem('companyid');
    const para = {
      p_companyid,
      p_plantid: 1,
      p_id_shift: id,
    };

    if (setLoading) setLoading(true);

    try {
      const data = await loadSelectedShiftDetail(para);    

      if (data?.[0]) {
        const d = data[0];
        setShiftCode(d.code || '');
        setCheckInTime(d.start_at ? dayjs(d.start_at, 'HH:mm') : null);
        setCheckOutTime(d.end_at ? dayjs(d.end_at, 'HH:mm') : null);
        setBreakDurationMins(d.break_mins || 0);
        setDescription(d.s_description || '');

        const breakDetails = typeof d.break_details === 'string'
          ? JSON.parse(d.break_details)
          : d.break_details;

        setBreaks(Array.isArray(breakDetails) ? breakDetails : []);
      }
    } catch (error) {
      alert(error.message || 'Failed to load shift details');
    } finally {
      if (setLoading) setLoading(false);
    }
  };

  return { loadShiftDetail };
};

export default useShiftDetailLoader;
